import type * as React from 'react';

import { useTranslation } from '@crehana/i18n';
import { useCountdown } from '@crehana/react-hooks';

const NumberContainer: React.FC<
  React.PropsWithChildren<{
    number: string;
    text: string;
    renderZero?: boolean;
  }>
> = ({ number, text, renderZero = true }) => {
  const formattedNumber =
    number.startsWith('0') && !renderZero ? number.substring(1) : number;

  return (
    <div className="flex flex-col items-center">
      <div className="flex">
        {formattedNumber.split('').map((char, index) => (
          <div
            // biome-ignore lint/suspicious/noArrayIndexKey: legacy code - suspicious/noArrayIndexKey
            key={`${char}-${index}`}
            className={`${
              index + 1 < formattedNumber.length ? 'mr-4' : 'mr-0'
            } h-36 w-24 px-2 bg-white text-black rounded-5 tw-font-pop font-extrabold text-20 leading-20 flex items-center justify-center sm:text-24 sm:leading-2text-24 lg:text-24 lg:leading-24`}
          >
            {char}
          </div>
        ))}
      </div>
      <p className="text-12 tw-font-pop text-white font-extrabold mt-8">
        {' '}
        {text}{' '}
      </p>
    </div>
  );
};

interface CountdownProps {
  endDate: string;
  titleTimer?: string;
}

const Countdown: React.FC<React.PropsWithChildren<CountdownProps>> = ({
  endDate,
  titleTimer,
}) => {
  const { days, hours, minutes, seconds } = useCountdown(new Date(endDate));
  const { t } = useTranslation();

  return (
    <div className="w-full items-center">
      <h6 className="font-body1 text-white text-center mb-12">
        {titleTimer || t('PROMO_ENDS')}
      </h6>
      <div className="flex justify-between">
        <NumberContainer number={days} renderZero={false} text="dias" />
        <NumberContainer number={hours} text="horas" />
        <NumberContainer number={minutes} text="minutos" />
        <NumberContainer number={seconds} text="segundos" />
      </div>
    </div>
  );
};

export default Countdown;
